import { render, staticRenderFns } from "./recoveBalance.vue?vue&type=template&id=062d6736&scoped=true"
import script from "./recoveBalance.vue?vue&type=script&lang=js"
export * from "./recoveBalance.vue?vue&type=script&lang=js"
import style0 from "./recoveBalance.vue?vue&type=style&index=0&id=062d6736&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "062d6736",
  null
  
)

export default component.exports